// @ts-check

import { useEffect, useRef } from "react";


/**
 * @typedef {import("./UseAutoResizeTextAreaTypes").UseAutoResizeTextAreaOptions} UseAutoResizeTextAreaOptions
 * 
 */


/**
 * Automatically resizes a textarea based on its content.
 * 
 * @param {string} textAreaHtmlId
 * @param {Array<any>} arrDependencies
 * @param {UseAutoResizeTextAreaOptions} [options]
 * 
 */
export function useAutoResizeTextArea(textAreaHtmlId, arrDependencies, options = {}) {

  let bottomMargin = options.bottomMargin || 10;
  
  
  
  let refDoResize = useRef(() => {});
  

  useEffect(() => {

    let x = document.getElementById(textAreaHtmlId);
    if (x == null) {
      return;
    }

    // Check if this textarea auto-resize has already been initialized.
    if (x.dataset.autoResizeInitialized === '1') {
      return;
    }
    

    function autoResize() {
      if (x == null) {
        return;
      }
      x.style.height = 'auto'; // reset height
      x.style.height = x.scrollHeight + bottomMargin + 'px'; // set to full scrollHeight
    }
    
    refDoResize.current = autoResize; // store the function in the ref for later use

    
    x.addEventListener('input', autoResize);
    x.dataset.autoResizeInitialized = '1'; // mark as initialized

    // if you pre-fill the textarea, call it once on load:
    autoResize();

  }, arrDependencies);
  
  
  
  // Return the function ref to allow external calls
  return refDoResize;

}




